module.exports = __webpack_public_path__ + "06887e8afeded664f57442c19e970201.png";